<template>
  <div>
    <p>
      {{ $t('check') }}
    </p>
    <ol>
      <li>
        {{ $t('p1') }} <mdicon name="lock-outline" />;
      </li>
      <li>
        {{ $t('p2') }}
      </li>
      <li>
        {{ $t('p3') }} <a @click="check">{{ $t('p3.check') }}</a>.
      </li>
    </ol>
  </div>
</template>

<script>
import { mdiLockOutline } from '@mdi/js';

export default {
  name: 'NotAllowedBlink',
  methods: {
    check() {
      this.$emit('check');
    },
  },
};
</script>

<style scoped>

</style>

<i18n locale="en" lang="yaml">
check: You have not given permission to access your camera or microphone.
p1: To the left of the site address, click on the lock icon
p2: Allow access to your camera and microphone;
p3: Refresh the page
p3.check: or click here
</i18n>

<i18n locale="ru" lang="yaml">
check: Вы не дали разрешение на доступ к камере или микрофону.
p1: Слева от адреса сайта нажмите на значок замка
p2: Разрешите доступ к камере и микрофону;
p3: Обновите страницу
p3.check: или нажмите сюда
</i18n>
